const documentTypeOptions = [
  { label: "Driving Licence", value: 0 },
  { label: "Passport", value: 1 },
  { label: "Utility Bill", value: 2 },
]

export default documentTypeOptions;
